// Vue
import {mixins} from 'vue-class-component'
import {Vue, Component, Prop} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Mixins
import {EventBus} from './../../../../mixins/event_bus/EventBus'

// Components
import {Icon} from '../../icon/Icon'

@Component({
    components: {Icon},
    mixins: [
        template,
    ]
})
export class TableCol extends mixins(EventBus) {

    @Prop()
    public col?: any

    @Prop({type: [String, Number]})
    public colKey?: string

    @Prop()
    public sortBy?: string

    @Prop()
    public sortOrder?: string

    @Prop({type: [Object, Array]})
    public data!: any[]

    public created () {

    }

    public handleSort(e: Event) {

        if (!this.col.sortable) return

        this.dispatch('Table', 'internalSort', [this.colKey])
        this.$emit('click', e)
    }
}